import { createElement } from 'react';

var component = function component(props) {
  return createElement("svg", Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  }, props), createElement("path", {
    d: 'M12.73 16.476c-.554-1.091-1.204-2.193-2.473-2.193-.242 0-.484.04-.707.142l-.43-.863c.525-.45 1.373-.808 2.464-.808 1.697 0 2.568.818 3.26 1.86.41-.89.605-2.093.605-3.584 0-3.724-1.165-5.636-3.885-5.636-2.68 0-3.839 1.912-3.839 5.636 0 3.704 1.159 5.596 3.84 5.596.425 0 .811-.047 1.166-.15Zm.665 1.3a7.128 7.128 0 0 1-1.83.244c-3.57 0-7.065-2.848-7.065-6.99C4.5 6.849 7.995 4 11.564 4c3.63 0 7.09 2.828 7.09 7.03 0 2.337-1.09 4.236-2.675 5.464.512.767 1.04 1.277 1.773 1.277.802 0 1.125-.62 1.179-1.105h1.043c.061.647-.262 3.334-3.178 3.334-1.767 0-2.7-1.024-3.4-2.224Z'
  }));
};

export { component };
//# sourceMappingURL=ItQuora-166c812e.js.map
